module.exports = __webpack_public_path__ + "img/cover15.c78099f8.png";